__turbopack_context__.v({
  "header": "_section-module__Ea0DDG__header",
  "section": "_section-module__Ea0DDG__section",
  "title": "_section-module__Ea0DDG__title",
});
